module.exports = __webpack_public_path__ + "static/img/typograph@t.d347818.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/discover/typograph@t.gif
// module id = mrPa
// module chunks = 0